import React from 'react'
import classes from './IndividualFilter.module.css'
const IndividualFilter = () => {
  // const selectedFilter = useSelector((state) => state.global.selectedFilter)
  // const dispatch = useDispatch()
  return (
    <div className={classes.box}>
      <div className={`${classes.chip} `}>Salary Summary</div>
    </div>
  )
}

export default IndividualFilter
